// Static fallback options for manuscript metadata dropdowns
// These are used when Product Config API data is unavailable
// IDs match the Product Config API response structure

// Default product ID for NGSS National manuscripts
export const NGSS_PRODUCT_ID = '0253faf8-c8e4-468f-afb9-10b816629965';

export const MAX_LESSON_NUMBER = 9999;
export const MAX_LESSON_TIME = 1440; // 24 hours in minutes
export const LESSON_TYPES = [
  { label: 'Real-World Phenomenon', value: 'a6429dbc-e61d-4725-8207-785701f570bd' },
  { label: 'Scientific Explanation', value: '15991a73-b5f6-45d3-9c4b-becb9ffc78de' },
  { label: 'Hands-On Activity', value: '3c4affb4-1e21-4164-ab55-7bd703bc79bb' },
  { label: 'Interactive', value: '12653e43-73b8-4447-9f1d-a9ca4be15550' },
  { label: 'Video', value: '8be2d654-6545-4d20-bacb-779c723f0e64' },
  { label: 'Literacy', value: '3f86a777-0eab-434a-ad6f-3b30bbb228f1' },
  { label: 'STEAM', value: '9908b2d5-d466-45f5-8e9a-c797cd07c044' },
  { label: 'Assessment', value: 'ea0d0d8b-3e0c-4581-bd16-f050875183dd' },
];

export const PAGE_LABELS = [
  { label: 'Real-World Phenomenon', value: 1039 },
  { label: 'Scientific Explanation', value: 1040 },
  { label: 'Hands-On Activity', value: 6 },
  { label: 'Interactive', value: 4 },
  { label: 'Video', value: 3 },
  { label: 'Literacy', value: 5 },
  { label: 'STEAM', value: 2071 },
  { label: 'Careers', value: 1033 },
  { label: 'Project', value: 2069 },
  { label: 'Assessment', value: 107 },
];

export const FIVE_E_CATEGORIES = [
  { label: 'Engage', value: '99cd311c-b4e9-43f4-b760-56c095794052' },
  { label: 'Explore', value: '6b937ddb-b93e-4547-aa98-64b006853678' },
  { label: 'Explain', value: 'ca0c36fa-405a-4e73-a068-d6f19d70c771' },
  { label: 'Elaborate', value: '46930edc-4068-4ce2-8b4c-a8242eb37da1' },
  { label: 'Evaluate', value: '6aec961b-3734-4dae-b75b-115cfd15ce35' },
];

export const DOMAINS = [
  { label: 'Earth', value: 'a4feb11b-27a7-4eef-97aa-74fa3ebd5987' },
  { label: 'Life', value: '7bf67987-b147-4d96-b0e5-296b765b2ded' },
  { label: 'Physical', value: '97568437-a9ba-4baf-bfc8-58fa5bbabf0c' },
];

export const LANGUAGE = [
  { label: 'English', value: 'eng' },
  { label: 'Spanish', value: 'spa' },
];

export const READING_LEVELS = [
  { label: 'Reading Level A', value: 10 },
  { label: 'Reading Level B', value: 11 },
];

export const GRADE_LEVELS = [
  { label: 'Pre-K', value: 'd1362e2c-c910-4ef1-ba3f-5cb692922c51' },
  { label: 'K', value: 'd7fc01bf-a0f3-4011-9704-1a66260a6992' },
  { label: '1', value: 'd24d43b2-1a43-443f-9cca-aa2680cb6d42' },
  { label: '2', value: '342bdef5-1004-4bd3-88a4-d1c81f020842' },
  { label: '3', value: 'cbb4d2a4-dda3-4f87-bddf-087abe5a8014' },
  { label: '4', value: '839aa7df-8a74-40be-90a1-1eff58eeb715' },
  { label: '5', value: 'bff68b3d-97cd-4ec4-a8c2-617d0b763bb4' },
  { label: '6', value: '5d4418a2-d98a-4212-88ad-c7ee11956ddd' },
  { label: '7', value: 'b10f8967-865e-45d9-af38-25a4308ef9c1' },
  { label: '8', value: '650b6512-e320-45a3-b00f-27c7d8d89972' },
  { label: '9', value: '08647bc6-cfaa-40c6-bbad-6ff637d43248' },
  { label: '10', value: '21f489f4-2f02-4319-a94d-436b87bb1a04' },
  { label: '11', value: '02854615-2815-46f8-89d1-d0c2e7e36b59' },
  { label: '12', value: '98bf25a0-f17c-451c-9514-bc247a8082f6' },
];
